"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@emotion/react");
var _styles = require("./styles");
var _Button = _interopRequireDefault(require("../../Button"));
var _Text = _interopRequireDefault(require("../../Text"));
var _contrastColor = require("../../../utils/contrastColor");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref = process.env.NODE_ENV === "production" ? {
  name: "mmvz9h",
  styles: "font-weight:400"
} : {
  name: "bhv4vb-buttonstep",
  styles: "font-weight:400;label:buttonstep;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
const Step = ({
  nr,
  selected,
  bidirectional,
  title,
  subTitle,
  onClick,
  trackingName = 'Bolig',
  trackingEvent = 'Søk om utleie click:  Stepper'
}) => {
  const theme = (0, _react2.useTheme)();
  const buttonstep = /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StepWrapper, {
    color: theme.primary,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
      nostyle: true,
      onClick: () => onClick(nr),
      trackingName: trackingName,
      trackingEvent: trackingEvent,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.FlexWrapper, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Circle, {
          selected: selected,
          color: theme.primary,
          bg: theme.bgLight,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
            size: "14px",
            color: selected ? (0, _contrastColor.getContrastColor)(theme.primary, theme.btnDefaultFontColor) : theme.defaultText,
            semibold: true,
            children: nr
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
          semibold: true,
          children: title
        }), subTitle && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SubTitleWrapper, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
            small: true,
            css: _ref,
            children: subTitle
          })
        })]
      })
    })
  });
  const step = /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StepWrapper, {
    color: theme.primary,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.FlexWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Circle, {
        selected: selected,
        color: theme.primary,
        bg: theme.bgLight,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
          size: "14px",
          color: selected ? theme.btnDefaultFontColor : theme.defaultText,
          semibold: true,
          children: nr
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
        semibold: true,
        children: title
      }), subTitle && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SubTitleWrapper, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
          small: true,
          children: subTitle
        })
      })]
    })
  });
  return selected ? buttonstep : bidirectional ? buttonstep : step;
};
var _default = exports.default = Step;